<template>
  <div>
    <SectionThree  :projectId="projectId" :show-download="true" />
  </div>
</template>
<script>
import SectionThree from "@/views/SectionThree.vue";

export default {
  components: { SectionThree },
  data() {
    return {
      projectId: "",
    };
  },
  created() {
    this.projectId = this.$route.params.id;
  },
  methods: {

  }
}
</script>
<style scoped>

</style>
